document.documentElement.classList.remove('no-js');

document.querySelectorAll('[data-nav-dropdown]').forEach(dropdown => {
  dropdown.addEventListener('toggle', () => {
    if (!dropdown.open) return;
    document.querySelectorAll('[data-nav-dropdown][open]').forEach(other => {
      if (other !== dropdown) other.removeAttribute('open');
    });
  });
});

document.addEventListener('click', event => {
  const menuButton = event.target.closest('[data-menu-toggle]');
  if (menuButton) {
    const mobileNavigation = document.querySelector('[data-mobile-nav]');
    mobileNavigation.hidden = !mobileNavigation.hidden;
    menuButton.setAttribute('aria-expanded', String(!mobileNavigation.hidden));
    return;
  }

  document.querySelectorAll('[data-nav-dropdown][open]').forEach(dropdown => {
    if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
  });
});

document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-nav-dropdown][open]').forEach(dropdown => dropdown.removeAttribute('open'));
});

document.addEventListener('click', event => {
  if (event.target.closest('[data-account-panel-open]')) {
    const mobileNavigation = document.querySelector('[data-mobile-nav]');
    if (mobileNavigation && !mobileNavigation.hidden) {
      mobileNavigation.hidden = true;
      const menuButton = document.querySelector('[data-menu-toggle]');
      if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
    }
  }
});
